import { configureStore } from "@reduxjs/toolkit";
import { NODE_ENV } from "../constant/environment";
import { theme } from "./reducer/theme";
import { menuBar } from "./reducer/menuBar";
import { font } from "./reducer/font";

const reducer = {
  theme,
  menuBar,
  font,
};

const store = configureStore({
  reducer,
  devTools: NODE_ENV !== "production",
});

export default store;
